var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelProduction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#AA0816"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6165 15.8631C17.1323 15.379 16.3473 15.379 15.8631 15.8631C15.379 16.3473 15.379 17.1323 15.8631 17.6165L18.8439 20.5972C19.6185 21.3719 19.6185 22.628 18.8438 23.4027L15.8631 26.3835C15.379 26.8677 15.379 27.6527 15.8631 28.1369C16.3473 28.621 17.1323 28.621 17.6165 28.1369L20.6088 25.1446C21.3843 24.3814 22.6318 24.3852 23.4026 25.1561L26.3835 28.1369C26.8677 28.621 27.6527 28.621 28.1369 28.1369C28.621 27.6527 28.621 26.8677 28.1369 26.3835L25.1465 23.3931C24.3851 22.6216 24.3845 21.3812 25.1446 20.6088L28.1369 17.6165C28.621 17.1323 28.621 16.3473 28.1369 15.8631C27.6527 15.379 26.8677 15.379 26.3835 15.8631L23.4027 18.8439C22.6312 19.6154 21.3822 19.6186 20.6068 18.8534L17.6165 15.8631Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelProduction);
export default __webpack_public_path__ + "static/media/cancelProduction.102fa433dda3d93768aa55275bcd34be.svg";
export { ForwardRef as ReactComponent };